import React from "react";
export default class MealBuilderDayStats extends React.PureComponent {
    render() {
        const { meals, dayNumber } = this.props;
        const calories = meals.reduce((prev, current) => prev + (current.nutriants.Calories || 0), 0).toFixed(2).replace(/\.00$/, "");
        const protein = meals.reduce((prev, current) => prev + (current.nutriants.Protein || 0), 0).toFixed(2).replace(/\.00$/, "");
        const carbs = meals.reduce((prev, current) => prev + (current.nutriants.Carbohydrates || 0), 0).toFixed(2).replace(/\.00$/, "");
        const fat = meals.reduce((prev, current) => prev + (current.nutriants.Fat || 0), 0).toFixed(2).replace(/\.00$/, "");
        const sugar = meals.reduce((prev, current) => prev + (current.nutriants.Sugar || 0), 0).toFixed(2).replace(/\.00$/, "");
        const sodium = meals.reduce((prev, current) => prev + (current.nutriants.Sodium || 0), 0).toFixed(2).replace(/\.00$/, "");
        return (React.createElement("div", { className: "plan-day-totals" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-auto" },
                    React.createElement("h2", { className: "h5" },
                        "Day ",
                        dayNumber,
                        " totals:")),
                React.createElement("div", { className: "col-md" },
                    React.createElement("dl", null,
                        React.createElement("dt", null, "Calories:"),
                        React.createElement("dd", null,
                            calories,
                            " kcal"),
                        React.createElement("dt", null, "Protein:"),
                        React.createElement("dd", null,
                            protein,
                            "g"),
                        React.createElement("dt", null, "Carbs:"),
                        React.createElement("dd", null,
                            carbs,
                            "g"),
                        React.createElement("dt", null, "Fat:"),
                        React.createElement("dd", null,
                            fat,
                            "g"))))));
    }
}
